import { API_URL } from './Api';

export const API_URN = '/v1/usuarios/pf';

export function DEPENDENTES_PESQUISA(id) {
  return {
    url: `${API_URL}${API_URN}/dependentes/${id}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function DEPENDENTE_EXCLUIR(id, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/dependente/${id}`,
    options: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function DEPENDENTE_CADASTRAR(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}`,
    options: {
      method: 'POST',
      headers: {
        'X-Forwarded-For': ipAddress,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
